module.exports = __webpack_public_path__ + "media/images/france-flag-round-6ea7abe502921b2e96ddc19a6075c8ee.png";